module.exports = __webpack_public_path__ + "static/media/users-class.ab56ac65.svg";